//import Account from './../../Resources/script.js'
import commonfunctions from "../../Resources/commonfunctions";

export default {
    name: 'AccountProduct',
    mixins: [commonfunctions],
    data () {
        return {
            product:{},
        }
    },

    components: {
        
    },
     
    methods: {

        setPage(){
            // this.product = this.$store.getters['account/getProduct'];
            // if(Object.keys(this.product).length > 0){
            //     this.loading = false;
            //     //get product details
            //     this.getSetProduct(this.product);
            // }
            //
            let self = this;
            localforage.getItem('xvue', function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.product = value.account.store_sellpoint.store_product;
                    if(Object.keys(self.product).length > 0){
                        self.loading = false;
                        //get product details
                        self.getSetProduct(self.product);
                    }
                }else{}
            });
        },

      
    },

    created: function(){console.log('h777ggg'+this.header_name)
        this.header_name = "mmmmm";console.log('h4444777ggg'+this.header_name)
        this.setMenuTabView('product','viewBusinessCategoryProduct','',''); //default view
        this.setPage();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoint/Product/script.js